module.exports = __webpack_public_path__ + "img/base_patrimoine_art_contemporain.91d7cab6.svg";